import { Link } from "@tanstack/react-router"

interface SectionHeaderProps {
  title: string
  linkHref?: string
}

export function SectionHeader({ title, linkHref }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between px-m py-3">
      <div className="text-base">{title}</div>
      {linkHref && (
        <Link to={linkHref} className="text-primary">
          Смотреть все
        </Link>
      )}
    </div>
  )
}
